import React, { useState, useEffect } from "react";

/* =========================
   MÁSCARA
========================= */
const maskCPF = (value) => {
    return value
        .replace(/\D/g, "")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
        .slice(0, 14);
};

/* =========================
   VALIDAÇÃO CPF
========================= */
const isValidCPF = (cpf) => {
    if (!cpf || cpf.length !== 11) return false;

    // Bloqueia repetição de dígitos
    if (/^(\d)\1{10}$/.test(cpf)) return false;

    let sum = 0;
    let remainder;

    for (let i = 1; i <= 9; i++) {
        sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    }

    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.substring(9, 10))) return false;

    sum = 0;
    for (let i = 1; i <= 10; i++) {
        sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    }

    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.substring(10, 11))) return false;

    return true;
};

/* =========================
   COMPONENTE
========================= */
const InputCPF = ({
    value = "",
    onChange,
    onValidChange,
    onBlur,
    placeholder = "Digite seu CPF",
    required = false
}) => {
    const [cpfNumeros, setCpfNumeros] = useState(value);
    const [erro, setErro] = useState(null);

    useEffect(() => {
        setCpfNumeros(value || "");
    }, [value]);

    const handleChange = (e) => {
        const onlyNumbers = e.target.value.replace(/\D/g, "").slice(0, 11);
        setCpfNumeros(onlyNumbers);
        onChange?.(onlyNumbers);

        if (onlyNumbers.length === 11) {
            const valido = isValidCPF(onlyNumbers);
            setErro(valido ? null : "CPF inválido");
            onValidChange?.(valido);
        } else {
            setErro(null);
            onValidChange?.(false);
        }
    };

    const handleBlur = () => {
        if (cpfNumeros.length === 11) {
            const valido = isValidCPF(cpfNumeros);
            setErro(valido ? null : "CPF inválido");
            onValidChange?.(valido);
        }

        if (typeof onBlur === "function") {
            onBlur(cpfNumeros);
        }
    };

    return (
        <div className="field-set">
            <input
                type="text"
                value={maskCPF(cpfNumeros)}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={placeholder}
                className={`form-control ${erro ? "is-invalid" : ""}`}
                maxLength={14}
            />
            {erro && <div className="invalid-feedback">{erro}</div>}
        </div>
    );
};

export default InputCPF;
